import * as CurrentUser from '../services/CurrentUser'
import { setCookie, getCookie } from 'redux-cookie'

export const RECEIVE_MY_SUBSIDIARIES = 'RECEIVE_MY_SUBSIDIARIES'
export const SET_CURRENT_SUBSIDIARY = 'SET_CURRENT_SUBSIDIARY'

export const RESET_STORE = 'RESET_STORE'

function findMySubsidiariesResponse(results) {
  return {
    type: RECEIVE_MY_SUBSIDIARIES,
    results: results
  }
}

export const findMySubsidiaries = () => (dispatch, getState) => {
  CurrentUser.getSubsidiaries().then ( (data) => dispatch(findMySubsidiariesResponse(data)) )
}

export const setCurrentSubsidiary = (id) => (dispatch, getState) => {
  dispatch(setCookie('selectedSubsidiary', id, { expires: 365 }))
  dispatch({type: SET_CURRENT_SUBSIDIARY, 'subsidiary': id})
  dispatch({type: RESET_STORE})
}

export const handleCurrentSubsidiary = () => (dispatch, getState) => {
  let selectedSubsidiary = dispatch(getCookie('selectedSubsidiary'))
  if (selectedSubsidiary) {
    dispatch(setCurrentSubsidiary(selectedSubsidiary))
  } else {
    CurrentUser.getSubsidiaries().then ( (data) => dispatch(setCurrentSubsidiary(data[0].ldapId)) )
  }
}
